import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  silent?: boolean;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (!this.props.silent) {
      console.error('Uncaught error:', error, errorInfo);
    }
    this.setState({
      error,
      errorInfo
    });
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.silent) return null;
      return (
        <div className="p-6 m-4 bg-red-50 border border-red-200 rounded-2xl">
          <h2 className="text-red-700 font-bold text-lg mb-2">Erro de Renderização</h2>
          <p className="text-red-600 text-sm mb-4">
            Ocorreu um erro interno ao exibir este componente. Por favor, tire um print desta tela.
          </p>
          <div className="bg-white/50 p-3 rounded-xl overflow-x-auto text-xs font-mono text-red-800">
            <strong>{this.state.error?.toString()}</strong>
            <br /><br />
            {this.state.errorInfo?.componentStack}
          </div>
          <button onClick={() => window.location.reload()} className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg font-bold text-sm">Recarregar</button>
        </div>
      );
    }

    return this.props.children;
  }
}
